import styled from 'styled-components';

export const Footer = styled.footer`
  padding: 4rem 0;

  @media (max-width: 50rem) {
    text-align: center;
  }
`;

export const Copywrite = styled.span`
  color: #718096;
  font-size: .8rem;
  font-style: italic;
`;

export const Menu = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #718096;

  > span {
    margin: 0 .5rem;
    pointer-events: none;
    color: #B0B1CC;
  }

  > a {
    display: inline-block;
    font-size: .80rem;
    color: #718096;
    line-height: 1.5;
    font-weight: 500;

    &:hover {
      color: #0070E0;
    }
  }
`;
